"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecentItemsExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getItemsPayload_1 = require("../../../shared/getItemsPayload");
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getRecentItems = toolkitRaw.createAsyncThunk('market/recentItems', async (params, { rejectWithValue }) => {
    try {
        const defaultParams = {
            limit: String((params === null || params === void 0 ? void 0 : params.limit) || '12'),
            sort: 'created_at',
            order: 'desc',
        };
        const query = new URLSearchParams(defaultParams).toString();
        const response = await services_1.default.get(`/api/market/items/search?${query}`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('market_search'),
            },
        });
        const items = (0, getItemsPayload_1.getItemsDeserializeFromApi)(response);
        return items.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getRecentItemsExtraReducers = (builder) => {
    builder.addCase(getRecentItems.pending, (state) => {
        state.recentItems.loading = true;
    });
    builder.addCase(getRecentItems.fulfilled, (state, action) => {
        state.recentItems.loading = false;
        state.recentItems.error = false;
        state.recentItems.data = action.payload;
    });
    builder.addCase(getRecentItems.rejected, (state) => {
        state.recentItems.loading = false;
        state.recentItems.error = true;
    });
};
exports.getRecentItemsExtraReducers = getRecentItemsExtraReducers;
exports.default = getRecentItems;
//# sourceMappingURL=index.js.map